export default "__VITE_ASSET__D7EEYoi2__"